export const LIVE_REGION_READY_DELAY = 100;
